'use client';

import { Shimmer } from '@shimmer-from-structure/react';

function DashboardStructure() {
  return (
    <div className="space-y-5 font-[family-name:var(--font-libre-franklin)]">
      <div className="flex items-center justify-between">
        <div className="space-y-2">
          <div className="h-7 w-64 rounded-lg bg-[#e5edf4]" />
          <div className="h-4 w-44 rounded-lg bg-[#e5edf4]" />
        </div>
        <div className="hidden h-10 w-32 rounded-lg bg-[#e5edf4] sm:block" />
      </div>
      <div className="grid gap-5 md:grid-cols-2 xl:grid-cols-4">
        {Array.from({ length: 4 }, (_, index) => <div key={index} className="h-28 rounded-2xl bg-[#e5edf4]" />)}
      </div>
      <div className="rounded-2xl bg-white p-5 shadow-[0_10px_28px_rgb(15,23,42,0.08)]">
        <div className="mb-6 h-6 w-52 rounded-lg bg-[#e5edf4]" />
        <div className="space-y-3">
          <div className="h-12 rounded-lg bg-[#e5edf4]" />
          {Array.from({ length: 5 }, (_, index) => <div key={index} className="h-14 rounded-lg bg-[#e5edf4]" />)}
        </div>
      </div>
    </div>
  );
}

function PublicStructure() {
  return (
    <div className="space-y-6">
      <div className="h-10 w-72 rounded-lg bg-[#e5edf4]" />
      <div className="h-5 w-96 max-w-full rounded-lg bg-[#e5edf4]" />
      <div className="grid gap-5 md:grid-cols-3">
        {Array.from({ length: 3 }, (_, index) => <div key={index} className="h-40 rounded-2xl bg-[#e5edf4]" />)}
      </div>
      <div className="h-72 rounded-2xl bg-[#e5edf4]" />
    </div>
  );
}

export function DashboardRouteLoading() {
  return (
    <Shimmer loading shimmerColor="rgba(255, 255, 255, 0.75)" backgroundColor="#e5edf4" duration={1.4}>
      <DashboardStructure />
    </Shimmer>
  );
}

export function PublicRouteLoading() {
  return (
    <Shimmer loading shimmerColor="rgba(255, 255, 255, 0.75)" backgroundColor="#e5edf4" duration={1.4}>
      <PublicStructure />
    </Shimmer>
  );
}
